<div class="backdrop" *ngIf="isVisible">
  <div class="dialog">
    <div
      class="icon"
      [ngClass]="{
        '!bg-[#40762A]': progress == 100,
        '!bg-[#b9251c]': response == 'ERROR'
      }"
    >
      <mdlz-icon [iconName]="loaderIcon" fillColor="#FFF"></mdlz-icon>
    </div>
    <div class="loader-wrapper" *ngIf="response !== 'ERROR'">
      <div
        class="label font-medium"
        [ngClass]="{
          'text-[#40762A]': progress == 100
        }"
      >
        {{ loaderLabel }}
      </div>
      <div class="loader">
        <div
          class="progress-bar"
          [style.width.%]="progress"
          [ngClass]="{
            '!bg-[#40762A]': progress == 100
          }"
        ></div>
      </div>

      <div class="loader-percent">{{ progress | number : '1.0-0' }}%</div>
    </div>

    <div class="process-failure-container flex-grow w-full h-full p-4 flex justify-left items-center" *ngIf="response === 'ERROR'">
      <div class="text-[#b9251c] text-xl font-semibold">Process Failed!</div>
    </div>
  </div>
</div>
